import React, { useState } from "react";
import { Button } from "./Button";
import { StepList, SectionTitle } from "./StepList";
import ModalDialog from "./ModalDialog.js";
import Alert from "./Alert.js";
import Callout from "./Callout.js";

const StyleGuide = (props) => {
	const [showAlert, setShowAlert] = useState(false);
	const [showModalDialog, setShowModalDialog] = useState(false);

	const handleToggleAlert = () => {
		setShowAlert(!showAlert);
	};

	const handleToggleModalDialog = () => {
		setShowModalDialog(!showModalDialog);
	};

	const modalPrimaryCallback = () => {
		alert("primary button click");
		handleToggleModalDialog();
	};

	const modalSecondaryCallback = () => {
		alert("secondary button click");
		handleToggleModalDialog();
	};

	return (
		<>
			<section className="page-content">
				<div className="container ">
					<div className="main-content-area full-width">
						<div className="main-content-area__wrapper">
							<h1>Style Guide</h1>

							<h2 className="step-list__step major">Introduction</h2>
							<p className="intro">
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo itaque soluta recusandae magni qui iste
								quasi quae in, nostrum quibusdam reprehenderit cumque similique alias eos. Sed ex assumenda modi cum!
							</p>
							<p className="intro">
								Cum, maiores neque libero illum ducimus incidunt ad inventore in labore tenetur adipisci repellat
								cupiditate quibusdam voluptatibus eaque. Distinctio quidem atque aliquam natus praesentium architecto
								molestiae repellat doloremque pariatur libero?
							</p>

							<h2 className="step-list__step major">Components</h2>

							<div className="flex-grid">
								<div className="component-card">
									<h3>Step List</h3>
									<p>Currently uses a fixed list of steps</p>
									<p>You provide the active step number</p>
									<StepList step="1" />
								</div>

								<div className="component-card">
									<h3>Section Title</h3>
									<p>Uses the same fixed list of steps</p>
									<SectionTitle step="1" />
								</div>

								<div className="component-card">
									<h3>Button</h3>
									<p>Was it worth abstracting this into a React Component? Eh, we're learning.</p>
									<Button
										onClick={() => {
											alert("Button clicked!");
										}}
									>
										Log To Console
									</Button>
								</div>

								<div className="component-card">
									<h3>Callout</h3>
									<Callout>Simple callout</Callout>
								</div>

								<div className="component-card">
									<h3>Alert</h3>
									<p>
										You must pass a callback capable of closing the alert... if you want the user to be able to close it
									</p>
									<p>Alerts accept a message </p>
									<p>Alerts do not yet accept any props to trigger styling</p>
									{showAlert ? (
										<Alert
											title="Example title"
											message="Example Alert message is overridden by children"
											close={handleToggleAlert}
											buttonTextPrimary="Say Hi 👋"
											onClickPrimary={(e) => e.preventDefault && alert("Hello There 👋")}
											buttonTextSecondary="Close alert"
											onClickSecondary={handleToggleAlert}
										/>
									) : (
										""
									)}
									<Button onClick={handleToggleAlert}>{showAlert ? "Hide Alert" : "Show Alert"}</Button>
								</div>

								<div className="component-card">
									<h3>Modal Dialog</h3>
									<p>Modals accept an optional close function.</p>
									<p>
										Modals accept an optional <code>primaryButtonName</code> and <code>primaryButtonCallback</code>.
									</p>
									<p>
										Modals accept an optional <code>secondaryButtonName</code> and <code>secondaryButtonCallback</code>.
									</p>
									<p>Modals do not yet accept any props to trigger styling</p>
									{showModalDialog ? (
										<ModalDialog
											message="Example ModalDialog message"
											title="Example Title"
											close={handleToggleModalDialog}
											primaryButtonName="Absolutely!"
											secondaryButtonName="Nope!"
											primaryCallback={modalPrimaryCallback}
											secondaryCallback={modalSecondaryCallback}
										/>
									) : (
										""
									)}
									<Button onClick={handleToggleModalDialog}>
										{showModalDialog ? "Hide Modal Dialog" : "Show Modal Dialog"}
									</Button>
								</div>
							</div>

							<h2 className="step-list__step major">Styles</h2>

							<p>Placeholder area for illustrating usage of reusable styles</p>
							<ul>
								<li>Responsive (mobile friendly) design</li>
							</ul>

							<h2 className="step-list__step major">JSX CheatSheet</h2>

							<ul>
								<li>
									<p>Properties and Attribues are camelCase</p>
									<p>HTML: maxlength</p>
									<p>JSX: maxLength</p>
								</li>
								<li>
									<p>Block Comments</p>
									<p>Blocks can be commented with {"{/* JSX */}"} </p>
									<p>See source for an example right here.</p>
								</li>
								<li>
									<p>Label For</p>
									<p>HTML: {'<label for="blah">'}</p>
									<p>JSX: {'<label htmlFor="blah">'}</p>
								</li>
								<li>
									<p>Class</p>
									<p>HTML: {'<div class="blah">'}</p>
									<p>JSX: {'<div className="blah">'}</p>
								</li>
							</ul>
							<p>
								More at: React Docs{" "}
								<a target="_blank" rel="noopener noreferrer" href="https://reactjs.org/docs/dom-elements.html">
									DOM Elements
								</a>{" "}
							</p>
							<p>
								More at: this{" "}
								<a target="_blank" rel="noopener noreferrer" href="https://devhints.io/react">
									Cheat Sheet
								</a>
							</p>

							<h2 className="step-list__step major">TODO</h2>
							<ul>
								<li>Style Component sections to clarify the part that is the component</li>
								<li>Style JSX examples to clarify that HTML is wrong</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default StyleGuide;
